import { render } from "./HelpDmvReg.vue?vue&type=template&id=753cebc6&scoped=true"
import script from "./HelpDmvReg.vue?vue&type=script&lang=js"
export * from "./HelpDmvReg.vue?vue&type=script&lang=js"

import "./HelpDmvReg.vue?vue&type=style&index=0&id=753cebc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-753cebc6"]])

export default __exports__